import { z } from "zod";

export const creditCardSchema = z.object({
  brand: z.string(),
  default: z.boolean(),
  expiration: z.string(),
  id: z.string(),
  last4: z.string().length(4),
});

export type CreditCard = z.infer<typeof creditCardSchema>;
